<template>
  <svg
    :id="genName"
    :data-name="genName"
    :width="size"
    :height="size"
    :style="genStyle"
    :class="className"
    :viewBox="`0 0 24 24`"
    xmlns="http://www.w3.org/2000/svg"
    v-html="icons[genName]"
  />
</template>
<script>
import icons from './bundle';

export default {
  name: 'AppIcon',
  props: {
    name: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'outline',
      validator: value => ['outline', 'fill'].includes(value),
    },
    size: {
      type: [String, Number],
      default: 24,
    },
    color: {
      type: String,
      default: 'none',
    },
    className: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      icons,
    };
  },
  computed: {
    genName() {
      if (!this.name) return '';
      return `${this.name}_${this.type}`;
    },
    genStyle() {
      const styles = {
        fill: {
          fill: this.color,
          'stroke-width': 0,
        },
        outline: {
          fill: this.color,
          stroke: this.color,
          'stroke-miterlimit': 10,
        },
      };
      return styles[this.type];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/app-icon/index.vue